'use strict';

exports.__esModule = true;
exports.weveGotYouCovered = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _weveGotYouCovered = require('../actions/weve-got-you-covered');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	hover: 'out',
	activeBox: 0
};
var weveGotYouCovered = exports.weveGotYouCovered = function weveGotYouCovered(state, action) {
	switch (action.type) {
		case _weveGotYouCovered.ON_MOUSE_ENTER:
			return (0, _assign2.default)({}, state, { hover: 'in' });
		case _weveGotYouCovered.ON_MOUSE_LEAVE:
			return (0, _assign2.default)({}, state, { hover: 'out' });
		case _weveGotYouCovered.UPDATE_ACTIVE_BOX:
			return (0, _assign2.default)({}, state, { activeBox: action.activeBox });
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/home-page/lib/reducers/weve-got-you-covered.js